var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NovoUnidadePolicial.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-ea1cd3da\",\"hasScoped\":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NovoUnidadePolicial.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/policia-civil/policiais/unidade-policial/components/NovoUnidadePolicial.vue
// module id = 1192
// module chunks = 17